<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { makeWebsiteRequest } from "../Common/tools";
  import Table from "../Table/Table.svelte";
  import AbandonedOrderDetails from "./AbandonedOrderDetails.svelte";
  import {External, M} from "../external";

  export let period = null,
    funnel = null,
    filters = [],
    contact = 0,
    search = "";

  const dispatch = createEventDispatcher();

  let loading = true,
    initialLoad = true,
    currentPage = 0,
    pagesCount = 0,
    itemsCount = 0,
    table = null,
    selection = null;

  let tableColumns = [
    { key: "id", label: M.CART_ID, class: "flex-none mw-120" },
    {
      key: "customerName",
      label: M.CUSTOMER,
      class: "flex-none mw-240",
      row: "modified",
      style: "font-size: 13px",
      rowLabel: function (order, column) {
        return order.customerEmail;
      }
    },
    {
      key: "createdDate",
      label: M.DATE,
      class: "flex-none mw-120",
      row: "modified",
      style: "font-size: 13px",
      rowLabel: function (row, column) {
        return row.createdTime;
      }
    },
    {
      key: "totalLbl",
      label: M.CART_VALUE,
      class: "flex-none",
      style: "font-size: 15px"
    },
    {
      key: "statusLbl",
      label: M.STATUS,
      rowClass: function (order, column) {
        return "order-status " + order.status.toLowerCase();
      },
      class: "flex-none mw-120"
    }
  ];

  let tableData = {
    columns: tableColumns,
    rows: []
  };

  let setRequestFilter = (request, stringify) => {
    request = request || {};

    request.contact = contact;

    if (filters.length > 0) {
      request.filters = stringify ? JSON.stringify(filters) : filters;
    }

    if (funnel) {
      request.funnel = funnel;
    }
    if (period && period.from) {
      request.from = External.Tools.dateToISOStr(period.from);
    }

    if (period && period.to) {
      request.to = External.Tools.dateToISOStr(period.to);
    }

    request.search = search;
    request.abandoned = true;
    return request;
  };

  let load = async (page) => {
    if (loading && !initialLoad) {
      return;
    }
    initialLoad = false;

    if (page === 0) {
      tableData.rows = [];
      selection = null;
    } else if (currentPage + 1 >= pagesCount) {
      return;
    }
    loading = true;

    let request = setRequestFilter(
      {
        page: page
      },
      true
    );

    let response = await makeWebsiteRequest({
      action: "getStoreOrders",
      method: "post",
      data: request
    });

    loading = false;
    if (!response.data) return;

    currentPage = page;
    pagesCount = response.data.pagesCount;
    itemsCount = response.data.count;

    response.data.items.forEach((item) => {
      fillItemDetails(item);
    });

    if (page === 0) {
      notifyItemsLoaded();
    }
    if (table) table.addRows(response.data.items);
  };

  let notifyItemsLoaded = () => {
    dispatch("itemsloaded", {
      count: itemsCount,
      label: M.ORDER_STATUS_ABANDONED
    });
  };

  let onNext = () => {
    load(currentPage + 1);
  };

  let onClickRow = (row) => {
    External.Tools.showWindow({
      isModal: false,
      withDarkBackground: true,
      noTitle: true,
      width: 1300,
      noNav: true,
      forceAtRight: true, //window.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(
            new AbandonedOrderDetails({
              target: popup.getContentArea(),
              props: {
                id: row.id
              }
            })
          );
        }
      }
    });
  };

  let fillItemDetails = (item) => {
    item.statusLbl = M["ORDER_STATUS_" + item.status] || item.status;
    item.totalLbl = External.WebPlatform.currToStr(item.total, External.Website.storeCurrencySymbol, External.Website.storeCurrencyPositionAtLeft, External.Website.storeCurrency, External.Website.storeCountry);
    var orderDate = External.WebsiteSettings.getDateFormat() === "uk" ? External.WebPlatform.ukDateTimeStringToDate(item.orderTime) : External.WebPlatform.usDateTimeStringToDate(item.orderTime);
    item.createdDate = External.WebPlatform.dateToStrWithMonth(orderDate, false, true);
    item.createdTime = item.orderTime.substr(item.orderTime.indexOf(" ") + 1);
  };

  export function reload() {
    load(0);
  }

  export function shouldSaveDataOnExit() {
    return false;
  }

  onMount(async () => {
    load(0);
  });
</script>

<Table
  bind:this={table}
  activeColumns={tableData.columns}
  data={tableData.rows}
  loading={loading}
  hideHeadOnLoad={true}
  hasSelection={false}
  bind:selection
  onClick={onClickRow}
  nextPage={onNext}
  tableClass={"orders-scrollable-table"}>
  <div class="col20 f-left coming-soon-block">
    <div class="col20 f-left t-center mb-25">
      <span class="material-icons-outlined fingerprint-icon" style="background: #f5f6fa;"> bubble_chart </span>
    </div>
    <div class="col20 f-left t-center">
      <h3>{M.NO_DATA_YET}</h3>
    </div>
  </div>
</Table>
